// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../creative-management/frontend/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../creative-management/frontend/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".creative-management-mf .v-radio[data-v-16f50751]{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
